import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ErrorTooltipModule } from '../../atoms/error-tooltip/error-tooltip.module';
import { RadioButtonComponent } from './radio-button.component';

@NgModule({
  imports: [CommonModule, ErrorTooltipModule],
  declarations: [RadioButtonComponent],
  exports: [RadioButtonComponent]
})
export class RadioButtonModule {}
